export const REGEX_PHONE_AND_MOBILE = /(^06\d{8}|07[3-9]\d{7}|^0[1-5]\d{8})$/;
export function cleanMaskedInput(val: unknown) {
  if (typeof val !== "string") return undefined;
  return val.replace(/\s/g, "");
}
